import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { BASE_URL, OTP_SEND } from '../../../constant-value';
import { useFormik } from 'formik';
import { validationRegisterSchema } from '../../../constant-value/schema';
import api from '../../../services/axiosConfig';
import { Link } from 'react-router-dom';


const CreateAccount = ({ nextStep, onSendData  }) => {
  const handleSendData = () => {
    // ارسال داده به والد از طریق تابع callback
    onSendData(body);
  };
  
  const [body, setBody] = useState({
    name: '',
    mobileNumber: '',
    password: '',
    confirmPassword: ''
  });

  const [otp, setOtp] = useState({
    phoneNumber: ''
  });

  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
} = useFormik({
    enableReinitialize: true,
    initialValues: body,
    validationSchema: validationRegisterSchema,    
    onSubmit: (values) => {

      api.post(`/${OTP_SEND}`, otp).then((res) => {
            if (res.data.isSuccess) {
                message(res.data.message,'success');
                handleSendData()
                nextStep();

            } else {
                message(res.data.message,'warn');
            }
        }).catch(error => { 
            message("جند دقیقه دیگر تلاش نمایید، خطایی رخ داده است", "warn");
        });
        // axios
        //   .post(`${BASE_URL}/${OTP_SEND}`, otp).then((res) => {
        //     if (res.data.isSuccess) {
        //         message(res.data.message,'success');
        //         handleSendData()
        //         nextStep();

        //     } else {
        //         message(res.data.message,'warn');
        //     }
        // }).catch(error => { 
        //     message("جند دقیقه دیگر تلاش نمایید، خطایی رخ داده است", "warn");
        // });
    },
});

  const changeHandle = (evt) => {
    setBody({
      ...body,
      [evt.target.id]: evt.target.value,
    })

    if (evt.target.id==='mobileNumber') {
      setOtp(prevOtp => ({ ...prevOtp, phoneNumber: evt.target.value }));
    }
  }

  const message = (message,type) => {
    if (type==='warn') {
      toast.warning(message, {
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      toast.success(message, {
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  return (
      <div className="container-fluid vh-100 bg-light">
        <div className="row h-100 justify-content-center align-items-center">
          <div className="col-md-6 col-lg-5">
            <div className="card shadow-sm border-0 rounded-4">
              <div className="card-body p-4 p-md-5">
                <h2 className="text-center mb-4 fw-bold text-primary">ثبت نام</h2>
                
      
                <form onSubmit={handleSubmit} className="rtl-form">
                  {/* نام */}
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label fw-medium">نام کامل</label>
                    <input
                      className={`form-control py-2 rounded-3 ${errors.name && touched.name ? 'is-invalid' : ''}`}
                      value={values.name}
                      onChange={changeHandle}
                      id="name"
                      type="text"
                      onBlur={handleBlur}
                      placeholder="نام و نام خانوادگی"
                    />
                    {errors.name && touched.name && (
                      <div className="invalid-feedback">{errors.name}</div>
                    )}
                  </div>

                  {/* شماره همراه */}
                  <div className="mb-3">
                    <label htmlFor="mobileNumber" className="form-label fw-medium">شماره همراه</label>
                    <input
                      className={`form-control py-2 rounded-3 ${errors.mobileNumber && touched.mobileNumber ? 'is-invalid' : ''}`}
                      value={values.mobileNumber}
                      onChange={changeHandle}
                      id="mobileNumber"
                      type="tel"
                      onBlur={handleBlur}
                      placeholder="09xxxxxxxxx"
                    />
                    {errors.mobileNumber && touched.mobileNumber && (
                      <div className="invalid-feedback">{errors.mobileNumber}</div>
                    )}
                  </div>

                  {/* رمز عبور */}
                  <div className="mb-3">
                    <label htmlFor="password" className="form-label fw-medium">رمز عبور</label>
                    <input
                      className={`form-control py-2 rounded-3 ${errors.password && touched.password ? 'is-invalid' : ''}`}
                      value={values.password}
                      onChange={changeHandle}
                      id="password"
                      type="password"
                      onBlur={handleBlur}
                      placeholder="حداقل 6 کاراکتر"
                    />
                    {errors.password && touched.password && (
                      <div className="invalid-feedback">{errors.password}</div>
                    )}
                  </div>

                  {/* تکرار رمز عبور */}
                  <div className="mb-4">
                    <label htmlFor="confirmPassword" className="form-label fw-medium">تکرار رمز عبور</label>
                    <input
                      className={`form-control py-2 rounded-3 ${errors.confirmPassword && touched.confirmPassword ? 'is-invalid' : ''}`}
                      value={values.confirmPassword}
                      onChange={changeHandle}
                      id="confirmPassword"
                      type="password"
                      onBlur={handleBlur}
                      placeholder="تکرار رمز عبور"
                    />
                    {errors.confirmPassword && touched.confirmPassword && (
                      <div className="invalid-feedback">{errors.confirmPassword}</div>
                    )}
                  </div>

                  <button 
                    className="btn btn-primary w-100 py-2 rounded-3 fw-bold" 
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        در حال ثبت نام...
                      </>
                    ) : 'ثبت نام'}
                  </button>
                </form>

                <div className="text-center mt-3">
                  <span className="text-muted">قبلاً ثبت نام کرده‌اید؟ </span>
                  <Link to="/login" className="text-decoration-none text-primary fw-medium">ورود به حساب</Link>
                </div>
                <div className="text-center mt-3">
                  <Link to="/privacy" className="text-decoration-none text-primary fw-medium">حریم خصوصی</Link>
                  <span className="text-muted">را می پذیرم</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* استایل‌های سفارشی */}
        <style>{`
          .rtl-form {
            direction: rtl;
            text-align: right;
          }
          .rounded-3 {
            border-radius: 0.5rem !important;
          }
          .invalid-feedback {
            text-align: right;
            display: block;
          }
        `}</style>
      </div>
  );
};

export default CreateAccount;